import React from 'react';

import { Block } from '@randajan/jet-react/dom/block';
import { Apiform } from '../../../elements/Apiform/Apiform';
import { page } from "../../../config/base";

import "./CallUs.scss";
import { LinkGdpr } from '../../Docs/Gdpr/Gdpr';


export const CallUs = (props)=>{
    const {} = props;
    
    return (
        <Block className="CallUs block wall">
            <Apiform name={"chat"} caption={"Jak Vám můžeme pomoci?"} rawput={{src:page.get("href")}} note={<LinkGdpr/>}>
                <Block caption="Děkujeme!">
                    <p>Vaši poptávku jsme zaznamenali.</p>
                    <p>Věnovat se vám budeme hned jak to bude možné.</p>
                </Block>
            </Apiform>
        </Block>
    )
}




